/**
 * Active Header
 * Making the header animate in on demand.
 */

const selectors = {
	application: '[data-application=defa-active-header]', // instantiation selector
};

const activeMenu = '.dl-active';                            // open menu selector


function ActiveHeader( element, options ) {
	element = element || selectors.application; // Default selector
	if ( !options ) {
		options = {};
	}
	
	let defaults       = {          // (obj) app defaults
			'enabled': 1,
		},
		settings,             // (obj) app settings
	
		iActivationTop = 60,   // (int) minimum top scroll to activate animations
		iScrollTop,           // (int) current scroll top
		tView,                // (timeout) last view
	
		$app,		          // (jQuery) the active element
		$window;              // (jQuery) the window
	
	
	// -----------------------------------------
	// Constructor
	// -----------------------------------------
	
	let init = function () {
		
		// setup instance settings
		settings = $.extend( true, {}, defaults, options );
		
		// setup instance elements
		$app    = $( element );
		$window = $( window );
		
		$window.on( 'resize', onResizeHandler );
		enableByWidth();
		// setup handlers and positioning
		setListeners();
	};
	
	
	// -----------------------------------------
	// Event Handlers
	// -----------------------------------------
	
	let onResizeHandler = function () {
		enableByWidth();
	};
	
	let scrollHandler = function ( /* event */ ) {
		let scrollTop = $window.scrollTop();
		
		// unset animations if we are at the top of the page.
		if ( scrollTop < iActivationTop ) {
			$app
				.removeClass( 'animated' )
				.removeClass( 'show' );
			
			clearTimeout( tView );
			
			// set, load and fire animation
		} else {
			if ( !$app.hasClass( 'animated' ) ) {
				$app.addClass( 'animated' );
				
				// show and start timeout if .dl-menu is active.
				if ( 1 === $app.find( activeMenu ).length ) {
					setTimeoutView();
				}
			}
			
			// show the element on reversed scroll
			if ( iScrollTop > scrollTop ) {
				setTimeoutView();
			}
		}
		
		iScrollTop = scrollTop;
	};
	
	
	// -----------------------------------------
	// Private functions
	// -----------------------------------------
	
	let enableByWidth = function () {
		
		if ( $window.innerWidth() >= 640 ) {
			_settings( { enabled: false } );
		} else {
			_settings( { enabled: true } );
		}
	};
	
	let setTimeoutView = function () {
		$app.addClass( 'show' );
		
		clearTimeout( tView );
		
		tView = setTimeout( function () {
			// only hide the header if the dl-menu is closed.
			if ( 0 === $app.find( activeMenu ).length ) {
				$app.removeClass( 'show' );
			} else {
				setTimeoutView();
			}
			
		}, 4000 );
	};
	
	
	let setListeners = function () {
		// tidy up / remove old listeners
		$window
			.off( 'touchmove', scrollHandler )
			.off( 'scroll', scrollHandler );
		
		// either add new listeners
		if ( settings.enabled ) {
			
			$window
				.on( 'touchmove', scrollHandler )
				.on( 'scroll', scrollHandler );
			
			// or remove all animation-classes
		} else {
			
			$app
				.removeClass( 'animated' )
				.removeClass( 'show' );
		}
	};
	
	let _settings = function ( newOptions ) {
		if ( newOptions ) {
			$.extend( settings, newOptions );
			setListeners();
		}
		
		return settings;
		
	};
	
	// -----------------------------------------
	// Public functions
	// -----------------------------------------
	
	this.settings = function ( newOptions ) {
		return _settings( newOptions );
	};
	
	
	init();
	return this;
}

export default ActiveHeader